import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { Moon, Sun } from 'lucide-react';

const ThemeToggle = () => {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6 transition-colors">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-gray-900 dark:text-gray-100 text-lg font-semibold mb-1">
            Theme
          </h2>
          <p className="text-gray-600 dark:text-gray-400 text-sm">
            Choose your preferred appearance
          </p>
        </div>
        {/* Toggle Switch */}
        <button
          onClick={toggleTheme}
          className={`relative inline-flex h-8 w-16 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 ${
            isDark ? 'bg-teal-600' : 'bg-gray-300'
          }`}
          role="switch"
          aria-checked={isDark}
          aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        >
          <span
            className={`inline-block h-6 w-6 transform rounded-full bg-white transition-transform flex items-center justify-center ${
              isDark ? 'translate-x-9' : 'translate-x-1'
            }`}
          >
            {isDark ? (
              <Moon className="w-4 h-4 text-gray-700" />
            ) : (
              <Sun className="w-4 h-4 text-yellow-500" />
            )}
          </span>
        </button>
      </div>
      {/* Current theme display */}
      <div className="flex gap-2">
        <button
          onClick={() => theme === 'dark' && toggleTheme()}
          className={`flex-1 py-2 px-4 rounded-lg border transition-colors flex items-center justify-center gap-2 ${
            theme === 'light'
              ? 'bg-teal-500 text-white border-teal-500'
              : 'bg-transparent text-gray-600 dark:text-gray-400 border-gray-300 dark:border-gray-600 hover:border-teal-500 dark:hover:border-teal-500'
          }`}
        >
          <Sun className="w-4 h-4" />
          Light
        </button>
        <button
          onClick={() => theme === 'light' && toggleTheme()}
          className={`flex-1 py-2 px-4 rounded-lg border transition-colors flex items-center justify-center gap-2 ${
            theme === 'dark'
              ? 'bg-teal-600 text-white border-teal-600'
              : 'bg-transparent text-gray-600 dark:text-gray-400 border-gray-300 dark:border-gray-600 hover:border-teal-500 dark:hover:border-teal-500'
          }`}
        >
          <Moon className="w-4 h-4" />
          Dark
        </button>
      </div>
    </div>
  );
};

export default ThemeToggle;




